/*
  eslint
  react/no-array-index-key: off
*/

import React, { PropTypes, PureComponent } from 'react';
import styles from './styles.scss';


/**
 * @type {PureComponent} Select PureComponent
 */
export class Select extends PureComponent {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    const { placeholder, options, value } = props;

    const selected = options.find(option => option.value === value);
    let label;
    if (selected) {
      label = selected.value;
    }
    if (!label) {
      label = placeholder || 'Add to...';
    }

    const open = false;
    this.state = {
      label, open,
    };
  }

  componentWillUpdate(__, nextState) {
    if (nextState.open) {
      return window.addEventListener('click', this.handleBlur);
    }
    return window.removeEventListener('click', this.handleBlur);
  }

  handleChange(option, onChange) {
    const { label } = option;
    if (onChange) {
      onChange(option.value);
    }

    this.setState({ label, open: false });
  }

  handleToggle() {
    this.setState({ open: !this.state.open });
  }

  handleBlur(event) {
    if (event.target !== this.select) {
      this.setState({ open: false });
    }
  }

  render() {
    const { props, state, handleChange } = this;
    const {
      options, onChange, tabIndex, className,
    } = props;
    const { label, open } = state;

    let labelView;
    if (typeof label === 'string') {
      labelView = <span className={styles.textLabel}>{label}</span>;
    } else {
      labelView = label;
    }

    let optionView; let optionViews;
    if (open) {
      optionViews = options.map((i, k) => (
        <div
          className={styles.option}
          key={k}
          onClick={() => handleChange(i, onChange)}
        >
          {i.listItem || i.label}
        </div>
      ));
      optionView = (
        <div className={styles.options}>
          {optionViews}
        </div>
      );
    }
    return (
      <div className={`${styles.view} ${className}`}>
        <div
          ref={(r) => { this.select = r; }}
          className={styles.select}
          onClick={this.handleToggle}
          tabIndex={tabIndex || 1000}
        >
          {labelView}
          <i
            className="fa fa-caret-down"
            aria-hidden="true"
          />
        </div>
        {optionView}
      </div>
    );
  }
}


/**
 * TODO: specify the component propTypes of Select
 * Select propTypes
 */
Select.propTypes = {
  tabIndex: PropTypes.number,
  className: PropTypes.string,
};


/**
 * default export
 */
export default Select;



// WEBPACK FOOTER //
// ./src/components/sign_up/shared/select/index.jsx